import React, { useState, useContext, useEffect } from 'react';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getAxiosInstance, getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useHistory } from 'react-router-dom';
import { Select } from 'antd';
import { Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import toast, { Toaster } from 'react-hot-toast';
import { v4 as uuid4 } from 'uuid';
import moment from 'moment';

const { Option } = Select;

function ApplyTc({ refetch, onClose, setLoading }) {
	const history = useHistory();
	const { collegeId } = useContext(FirebaseContext);
	const [name, setName] = useState({});
	const [DoLeaving, setDoLeaving] = useState('');
	const [SemesterfromLeaving, setSemesterfromLeaving] = useState('');
	const [Exam, setExam] = useState('');
	const [Streason, setStreason] = useState('');
	const [Letter, setLetter] = useState('');
	const [seletedUser, setSeletedUser] = useState({});
	const [sections, setSections] = useState([]);

	const semesters = ['l Semester', 'll Semester', 'lll Semester', 'lV Semester', 'V Semester', 'Vl Semester', 'Vll Semester', 'Vlll Semester', 'lX Semester', 'X Semester'];
	const reasons = ['Course Completed', 'Discontinued', 'College Transfer', 'Higher Studies'];
	const exams = ['Not attended', 'l Semester', 'll Semester', 'lll Semester', 'lV Semester', 'V Semester', 'Vl Semester', 'Vll Semester', 'Vlll Semester', 'lX Semester', 'X Semester'];

	const getDetails = async () => {
		try {
			const instance = getAxiosInstance();
			const { data } = await instance.get('/college/action/getTcSettings', {
				params: { collegeId, tcSettings: 'tcSettings', tcSections: 'tcSections' },
			});
			return data;
		} catch (error) {
			console.error('Error in getDetails:', error);
			throw error;
		}
	};

	const { data: sectionsData, isFetched } = useQuery(['sections', { collegeId }], getDetails, {
		cacheTime: 60 * 30 * 1000,
		refetchOnWindowFocus: false,
	});

	useEffect(() => {
		if (isFetched && sectionsData?.statusCode === 200) {
			if (sectionsData?.tcSettings?.sections) {
				let allFields = [
					...sectionsData.tcSettings?.sections.map((item) => {
						if (item._id) {
							return item;
						} else {
							return { ...item, _id: uuid4() };
						}
					}),
					...sectionsData?.tcSettings?.customFields?.map((item) => {
						if (item._id) {
							return item;
						} else {
							return { ...item, _id: uuid4() };
						}
					}),
				];
				let isAlreadyAdded = ['reasonForLeaving', 'characterAndConduct', 'name', 'exam', 'leavingSem', 'shortName', 'dateOfLeaving', 'aprovedOn', 'appliedOn', 'longName'];
				allFields = allFields.filter((item) => {
					if (item.checked && item?.keyName) {
						if (isAlreadyAdded.includes(item.keyName)) {
							return false;
						} else {
							isAlreadyAdded.push(item.keyName);
						}
						return true;
					}
				});

				setSections(allFields);
			}
		}
	}, [sectionsData]);

	useEffect(() => {
		if (seletedUser && seletedUser?._id && sections) {
			console.log(sections);

			setSeletedUser((prev) => {
				let newObj = {};
				sections.forEach((item) => {
					if (item.keyName) {
						if (item.type === 'date') {
							newObj[item.keyName] = moment(prev[item.keyName]).format('YYYY-MM-DD');
						} else {
							newObj[item.keyName] = prev[item.keyName] || '';
						}
					}
				});
				return { ...newObj };
			});
		}
	}, [seletedUser?._id]);

	const getClassesList = async () => {
		const instance = await getAxiosTokenInstance();
		const resp = await instance.get('/college/classes/getClass', {
			params: { collegeId },
		});
		return resp?.data;
	};

	const getUserList = async () => {
		const instance = await getAxiosTokenInstance();
		const resp = await instance.get(`college/transferCertificate/get?collegeId=${collegeId}&type=student`);
		return resp?.data;
	};

	const classQuery = useQuery(['classes', { collegeId }], getClassesList, { cacheTime: 60 * 30 * 1000, refetchOnWindowFocus: false });
	const { data: userList } = useQuery(['userListstudent', { collegeId }], getUserList);

	return (
		<Main width='50%' title='Apply for TC' height='100%' onClick={onClose}>
			<Toaster />
			<div className='bg-white p-6 rounded-lg shadow-lg max-w-4xl mx-auto relative w-full h-full overflow-y-scroll'>
				{/* User Selection and Basic Info */}
				<div className='grid grid-cols-2 gap-5'>
					{/* Full Name */}
					<div>
						<label className='block text-sm font-medium text-gray-700 mb-2'>Full Name</label>
						<Select
							showSearch
							value={name.name}
							className='w-full'
							placeholder='Select Full Name'
							onChange={(val) => {
								const selectedUser = userList?.list.find((x, i) => i + '-' + x.name + '-' + x.admisionNo === val);
								setName({ name: selectedUser.name, userId: selectedUser._id });
								setSeletedUser(selectedUser);
							}}>
							{userList?.list?.map((item, i) => (
								<Option key={i + '-' + item.name + '-' + item.admisionNo} value={i + '-' + item.name + '-' + item.admisionNo}>
									{item.admisionNo} - {item.name}
								</Option>
							))}
						</Select>
					</div>

					{/* Date of Leaving */}
					<div>
						<label className='block text-sm font-medium text-gray-700 mb-2'>Date of Leaving</label>
						<input type='date' value={DoLeaving} onChange={(e) => setDoLeaving(e.target.value)} className='w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500' />
					</div>

					{/* Semester from Leaving */}
					<div>
						<label className='block text-sm font-medium text-gray-700 mb-2'>Semester from Leaving</label>
						<Select value={SemesterfromLeaving} className='w-full' onChange={(val) => setSemesterfromLeaving(val)}>
							{semesters.map((sem, index) => (
								<Option key={index} value={sem}>
									{sem}
								</Option>
							))}
						</Select>
					</div>

					{/* Examination Last Appeared */}
					<div>
						<label className='block text-sm font-medium text-gray-700 mb-2'>Examination Last Appeared</label>
						<Select value={Exam} className='w-full' onChange={(val) => setExam(val)}>
							{exams.map((exam, index) => (
								<Option key={index} value={exam}>
									{exam}
								</Option>
							))}
						</Select>
					</div>

					{/* Reason for Leaving */}
					<div>
						<label className='block text-sm font-medium text-gray-700 mb-2'>Reason for Leaving</label>
						<Select value={Streason} className='w-full' onChange={(val) => setStreason(val)}>
							{reasons.map((reason, index) => (
								<Option key={index} value={reason}>
									{reason}
								</Option>
							))}
						</Select>
					</div>
					{sections &&
						sections
							?.filter((x) => x.keyName && x.checked && x.type)
							?.map((item, index) => (
								<div key={index}>
									<label className='block text-sm font-medium text-gray-700 mb-2'>{item.title || item.longTitle}</label>
									{item.type === 'array' ? (
										<Select value={seletedUser[item.keyName]} className='w-full' onChange={(val) => setSeletedUser({ ...seletedUser, [item.keyName]: val })}>
											{item.options?.map((option, idx) => (
												<Option key={idx} value={option.value}>
													{option.label}
												</Option>
											))}
										</Select>
									) : item.type === 'date' ? (
										<input type='date' value={seletedUser[item.keyName]} onChange={(e) => setSeletedUser({ ...seletedUser, [item.keyName]: e.target.value })} className='w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500' />
									) : (
										<input type='text' value={seletedUser[item.keyName]} onChange={(e) => setSeletedUser({ ...seletedUser, [item.keyName]: e.target.value })} className='w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500' />
									)}
								</div>
							))}
				</div>

				<label className='block mt-4 mb-2 font-medium'>Remarks (Optional)</label>
				<textarea className='w-full p-2 border rounded-md' value={Letter} onChange={(e) => setLetter(e.target.value)} rows='5' placeholder='Write your remarks here...' />

				<div className='mt-6 text-center'>
					<button
						className='bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 transition duration-200'
						onClick={async () => {
							try {
								setLoading(true);
								const instance = await getAxiosTokenInstance();
								const response = await instance.post('/college/transferCertificate/requestForTcCcNew', {
									collegeId,
									userId: name.userId,
									dateOfLeaving: DoLeaving,
									requestLetter: Letter,
									reasonForLeaving: Streason,
									exam: Exam,
									leaving: SemesterfromLeaving,
									userfields: seletedUser,
								});

								console.error({ response });
								if (response.status !== 200) {
									throw new Error(`Request failed with status ${response.status}: ${response.statusText}`);
								}
								setName('');
								setDoLeaving('');
								setSemesterfromLeaving('');
								setExam('');
								setStreason('');
								setLetter('');

								refetch();
								onClose();
								toast.success(`succesfully requested`);
							} catch (error) {
								console.error('Error submitting the form:', error);
								toast.error(`Failed to submit: ${error.message}`);
							} finally {
								setLoading(false);
							}
						}}>
						Submit
					</button>
				</div>
			</div>
		</Main>
	);
}

export default ApplyTc;
